import $ from 'jquery';
import { update } from '../../helpers/data-bind';
import * as config from '../../core/config';
import * as lightbox from '../../helpers/lightbox';

var privateScope = {};
var publicScope = {};

privateScope.formatSupplierDataUrl = function(supplierId) {
  return (config.getBaseUrl() + config.get('marketplace.supplier.url')).replace(
    '%1',
    supplierId
  );
};

privateScope.getTemplate = function() {
  return $(config.get('marketplace.supplier.selector')).html();
};

privateScope.onSuccess = function(data) {
  update(
    data,
    lightbox
      .setConfig({ className: 'supplier-details' })
      .open(privateScope.getTemplate())
      .getContent()
  );

  lightbox
    .getContent()
    .find('.supplier-details--row')
    .each(function() {
      let iLength = 0;
      const $this = $(this);

      $this.find('span').each(function() {
        iLength += $(this).html().length;
      });

      if (iLength === 0) {
        $this.hide();
      }
    });
};

publicScope.showSupplierOverlay = function(supplierId) {
  $.getJSON(
    privateScope.formatSupplierDataUrl(supplierId),
    privateScope.onSuccess
  );
};

publicScope.init = function() {
  $('[data-supplier-id]').on('click', function(event) {
    event.preventDefault();
    publicScope.showSupplierOverlay($(this).attr('data-supplier-id'));
  });
};

privateScope.getOrderItemPosition = function(orderId, sku) {
  var $offset = $('[data-order-id="' + orderId + '"]')
    .find('[data-sku="' + sku + '"]')
    .first()
    .offset();

  return $offset ? $offset.top - parseInt($(window).height() / 2, 10) : 0;
};

privateScope.scrollToOrderItem = function(position, supplierId) {
  let scrollTop = parseInt(position, 10);

  if (scrollTop < 0) {
    scrollTop = 0;
  }

  $('body, html').animate(
    {
      scrollTop
    },
    config.getInt('marketplace.scrollSpeed'),
    function() {
      publicScope.showSupplierOverlay(supplierId);
    }
  );
};

publicScope.preopenOverlay = function(orderId, sku, supplierId) {
  privateScope.scrollToOrderItem(
    privateScope.getOrderItemPosition(orderId, sku),
    supplierId
  );
};

publicScope.init();

const w = window;

w.home24 = w.home24 || {};
w.home24.marketplace = publicScope;



/** WEBPACK FOOTER **
 ** ./legacy/home24/modules/common/marketplace.js
 **/